module.exports = __webpack_public_path__ + "img/bee002.20da7b43.svg";